
import { defineComponent, computed, ref } from "vue";
import { getCSSVariableValue } from "@/assets/ts/_utils";

export default defineComponent({
  name: "kt-widget-1",
  props: {
    widgetClasses: String,
    color: String,
  },
  components: {},
  setup(props) {
    const items = [
      {
        logo: "media/svg/brand-logos/aven.svg",
        name: "รายการขายปลีก",
        tools: "Retail Sales",
        company: "1,067",
        skills: "Web, UI/UX Design",
        progress: "65%",
        color: "danger",
        percent: "1.5%",
      },
      {
        logo: "media/svg/brand-logos/leaf.svg",
        name: "รายการขายส่ง",
        tools: "Whole Sales",
        company: "24,588",
        skills: "Houses & Hotels",
        progress: "85%",
        color: "primary",
        percent: "2.5%",
      },
      {
        logo: "media/svg/brand-logos/atica.svg",
        name: "รายการซื้อ",
        tools: "Purchases",
        company: "974",
        skills: "Transportation",
        progress: "40%",
        color: "success",
        percent: "3%",
      },
    ];

    return {
      items,
    };
  },
});
